module.exports = __webpack_public_path__ + "static/media/adapted-blue.cae367e2.svg";